import { FormFile as CommonFormFile } from '@monorepo/common';
import type { FieldValues, UseControllerProps } from 'react-hook-form';

// ファイル形式の定数
const ACCEPTED_FILE_TYPES = [
  'image/png',
  'image/jpeg',
  'image/jpg',
  'image/webp',
  'image/heic',
  'video/mp4',
  'video/quicktime',
  'video/x-msvideo',
  'video/hevc',
  'video/mp4; codecs=hevc',
  'video/hevc; codecs=hvc1',
  '.heic',
  '.hevc',
  '.mov',
  '.mp4',
].join(', ');

type Props<T extends FieldValues> = {
  label?: string;
  required?: boolean;
  accept?: string;
} & UseControllerProps<T>;

function FormFile<T extends FieldValues>({
  name,
  label,
  required = false,
  control,
  accept = ACCEPTED_FILE_TYPES,
}: Props<T>) {
  return <CommonFormFile name={name} label={label} required={required} control={control} accept={accept} />;
}

export default FormFile;
